document.addEventListener('DOMContentLoaded', () => {
    IMask(
        document.querySelector('[name="phone"]'),
        {
            mask: '+38 (000) 000-00-00',
        }
    )
})